(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("loginPageDefaults", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/settings/user/loginPageDefaults/loginPageDefaultsView.html",
            controller: ["frameworkService", "homePageService", "messageService", "tenantResource", LoginPageDefaultsCtrl],
            controllerAs: "vm"
        };
        function LoginPageDefaultsCtrl(frameworkService, homePageService, messageService, tenantResource) {
            var vm = this;
            vm.saving = false;
            vm.selectedPage = frameworkService.data.tenant.defaultHomePageTypeId;
            vm.pages = homePageService.getAllPossibleHomePages();
            vm.save = function () {
                vm.saving = true;
                tenantResource.saveDefaultLoginPage({ value: vm.selectedPage }, function () {
                    messageService.success("common.changesSaved");
                    frameworkService.data.tenant.defaultHomePageTypeId = vm.selectedPage;
                    vm.saving = false;
                }, function (error) {
                    messageService.error(error);
                    vm.saving = false;
                });
            };
        }
    });
}());
